// Client half of the org retention policy: chats live in the browser and
// sync up, so expired chats must be dropped locally too (otherwise the next
// sync would re-upload what the server just expired). Mirrors
// server/lib/governance.js chatActivityMs/applyChatRetention.

export function chatActivityMs(c) {
  if (!c || typeof c !== "object") return 0;
  let t = Math.max(Number(c.updated) || 0, Number(c.updatedAt) || 0, Number(c.created) || 0);
  if (Array.isArray(c.messages)) for (const m of c.messages) t = Math.max(t, Number(m && m.time) || 0);
  return t;
}

// Returns the same array (identity) when nothing expires, so React state
// setters can bail out without a re-render.
export function pruneExpiredChats(chats, policy, now = Date.now()) {
  if (!Array.isArray(chats) || !policy || !policy.chatRetentionDays || policy.legalHold) return chats;
  const cutoff = now - policy.chatRetentionDays * 86400000;
  const kept = chats.filter((c) => { const t = chatActivityMs(c); return !t || t >= cutoff; });
  return kept.length === chats.length ? chats : kept;
}
